<template>
    <div class="body">
        <p  class="font1" style="padding-top: 10vh;">读书不觉已春深</p>
        <p  class="font1" style="padding-top: 1vh;">一寸光阴一寸金</p>

        <p  class="font2" style="padding-top: 5vh;">推荐书籍如下：</p>

        <div class="wrapper">
            <div class="bookTextOne">
                <h3 style="text-align: center;">《大野耐一的现场管理》</h3>
                <p style="padding-bottom: 4px;width: 100%;">作者：大野耐一</p>
                <div id="qiymet2" @click="openPDF(2)">
                    <p>
                        <i class="fa fa-eye fa-2x"></i>
                    </p>
                </div>
            </div>
            <div class="bookTextTwo">
                <h3 style="text-align: center;">《改变世界的机器》</h3>
                <p style="padding-bottom: 4px;">作者:詹姆斯·P·沃麦克、丹尼尔·T·琼斯、丹尼尔·鲁斯</p>
                <div id="qiymet1" @click="openPDF(1)">
                    <p>
                        <i class="fa fa-eye fa-2x"></i>
                    </p>
                </div>
            </div>
        </div>

        <div class="dialog" v-show="bookShow">
            
            <i style="margin-left:95%;color: #090808;" @click="bookShow = false" class="fa fa-close fa-1x"></i>
          
            <div v-if="this.bookPage==1" style="text-align: justify;width: 100%;">
                <div style="width: 90%;margin: 0 auto;">
                  本书采用大野语录的形式，全面阐释了大野耐一始创的"丰田生产方式"的思想内涵和精神。<br><br>
                  核心内容：<br><br>
                  1.潜藏在常识中的错觉 2.数学计算的误区 3.不要害怕损失机会 4.准时制生产 5.降低成本唯有依靠现场 6.改善应该按顺序进行<br>
                  <p style="font-size: 15px; color: chocolate;">*详情请登录富学宝典范搜索“卓越基因”查看！</p>
                </div>
            </div>
            <div v-if="this.bookPage==2" style="text-align: justify;">
                <div style="width: 90%;margin: 0 auto;">
                  精益生产的故事——丰田在全球汽车大战中的秘密武器，引发了全球的工业革命。<br><br>
                1990年，当《改变世界的机器》首次出版时，丰田的规模只有通用的1/2、福特的2/3。然而今天，本书为新一代读者再次出版时，丰田已经轻易超过了福特并赶超通用，成为全球第一、长盛不衰的工业企业。本书将讲述其中的缘由。<br><br>  
                然而，这不仅仅是一个巨型行业内三巨头的故事。本书的巨大贡献是，它明确阐述了两大根本不同的业务系统，两种人类如何合作创造价值的思维方式。由通用首创的大批量生产系统使其成为当时世界上最大的工业企业。之后将近75年，这个系统被世界上所有行业广泛复制和使用。另外一个业务系统——由丰田开创的精益生产，现今已快速传播到世界各个角落。向精益转型将会为人类社会带来深远影响——它将真正改变世界。
                <p style="font-size: 15px; color: chocolate;">*详情请登录富学宝典范搜索“基业长青”查看！</p>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
export default {
  props: {
    ReportData: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      widthWindow: window.innerWidth, 
      widthBlock: window.innerWidth*0.47,
      heightBlock: window.innerHeight*0.257,
      bookPage: 1,
      bookId: 0,
      bookShow: false,
    }
  },
  created() {
    
  },
  methods: {
    openPDF(bookPage) {
      if(bookPage === 1){
        this.bookPage = 1
        this.bookId = 1
      } else {
        this.bookPage = 2
        this.bookId = 2
      }
      this.bookShow = true
    },
  }
}
</script>
  
  <style scoped>
  .body {
      background:url("../../assets/year23/bg3.jpg")  no-repeat;
      background-size: 100% 100%,cover;
      width: 100%;
      height: 100vh;
      display: flex;
      flex-direction: column;  
      align-items: center;  
  }
  .font1 {
      width: 80%;
      margin: 0;
      text-align: center;
      font-size: 20px;
      color: #fff;
      font-weight: bold;
      font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }
  .font2 { 
      width: 80%;
      margin: 0 auto;
      padding: 0;
      color: #fff;
      font-size: 20px;
      font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }
  .font3 {
      font-size: 20px;
      font-weight: bold;
      color: #953b5d;
      text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
      font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
  }
  .dialog {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      z-index: 2000;
      /* bottom: 20%; */
      width: 91%;
      height: auto;
      background: #fff;
      border-radius: 7px;
      padding: 7px;
      box-shadow: #eae62ebd 1px;
  }

  .fa {
      color: #fff8e8;
  }


  .wrapper {
      z-index: 1000;
      width: 97%;
      /* height: auto; */
      height: 54vh;
      display: flex;
      justify-content: center;
      background-color: rgba(255, 255, 255, 0.5);
      border-radius: 10px;;
      border-radius: 17px;
      margin: 0 auto;
      flex-wrap: wrap;
  }

  .bookOne {
      width: 30%;
      height: 20%;
      /* margin-top: 10px; */
  }

  .bookTwo {
      width: 30%;
      height: 20%;
  }

  .bookTextOne {
      margin-left: 11px;
      width: 90%;
      height: 120px;
      color: #000;
  }
  .bookTextTwo {
      margin-left: 4px;
      margin-right: 11px;
      width: 90%;
      height: 120px;
      color: #000;
    }

    #qiymet2 {
      float: right;
      margin-right: 20px;
      margin-top: -17px;
      padding: 0px 17px 0px 17px;
      border-radius: 20px;
      color: #000;
      font-family: 'Source Code Pro', cursive;
      background-color: rgb(39, 178, 217);
  }

  #qiymet1 {
      float: left;
      margin-right: 20px;
      margin-top: -17px;
      padding: 0px 17px 0px 17px;
      /* width: 51px;
      height: 51px; */
      border-radius: 20px;
      color: #000;
      font-family: 'Source Code Pro', cursive;
      background-color: rgb(39, 178, 217);
      z-index: 1000;
  }

  .zezhao {
      width: 100%;
      height: 100%;
      background: #000000bc;
      z-index: 1920;
      position: absolute;
  }

  button {
      border: none;
      outline: none;
      background-color: rgb(39, 178, 217);
      padding: 10px 20px;
      font-size: 12px;
      font-weight: 700;
      color: #fff;
      border-radius: 5px;
      transition: all ease 0.1s;
      box-shadow: 0px 5px 0px 0px rgb(116, 219, 247);
      margin: 5px;
  }

  button:active {
      transform: translateY(5px);
      box-shadow: 0px 0px 0px 0px rgb(116, 219, 247);
  }

  .donghua{
      animation:flash 3s infinite
    }
    @keyframes flash {
      0% {
        opacity: 0;
      }
      80% {
        opacity: 1;
      }
      100% {
        opacity: 0;
      }
  }
  </style>